import { useState, useContext, useEffect } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { MdOutlineDelete } from "react-icons/md";

import { AppContext } from "../../../Context";
import { PiStudent, PiPencil, PiBuildingsLight } from "react-icons/pi";
import { MdOutlineArrowLeft, MdOutlineRemoveRedEye, MdModeEdit, MdOutlineCleaningServices } from "react-icons/md";

import Fetch, { Loader, GET, DateToText, SecoundsToTime } from "../../../inc/Fetch"; 
import { ClassesDropdown } from "../../../components/Form"; 
import Task from "./Task"; 
import Permission from '../../Permission'

import './css/Teacher_tasks.css'

export default function Teachers_tasks() {

    const { t } = useTranslation();
    const params = useParams();

    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;

    const [loading, setloading] = useState(false);


    async function loadData() {
        let r = await GET(`task/viewMyTask?_id=${params?.id}`);
        return r;
    }

    function deleteAnswers(st) {

        const conf = window.confirm(t("error",  { returnObjects: true })[2]);
        if (!conf) {
            return false;
        }

        setloading(true);
        Fetch("task/deleteStudentAnswers", (d) => {

            if (d?.error) {
                setopen({ error:true, short: t("error",  { returnObjects: true })[d?.error] });
            } else {

                // setopen({ error:false, short:t("tasks_sent_success") });
                loadData();
            }
            
            setloading(false);
        }, { student:st, _id: params?.id });
    }

    const { data, error, isLoading } = useQuery(`myTasksInfo_${params?.id}`, loadData); 

    useEffect(() => {
        const script = document.createElement('script');
        
        script.src = "https://teams.microsoft.com/share/launcher.js";
        script.async = true;
        script.defer = true;
        
        document.body.appendChild(script);
        
        return () => {
            document.body.removeChild(script);
        }
    }, []);
    
    useEffect(() => {
        const script = document.createElement('script');
        
        script.src = "https://apis.google.com/js/platform.js";
        script.async = true;
        script.defer = true;
        
        document.body.appendChild(script);
        
        return () => {
            document.body.removeChild(script);

            window.___gcfg = {
                parsetags: 'onload'
            };
        }
    }, []);

    if (isLoading) {
        return  <Loader />;
    }

    if (userinfo?.userlevel < 3) {
        return <Permission />
    }
    
    if (userinfo?._id != data?.task?.user?._id) {
        return <Permission />
    }

    
    return (
        <div className='teacherTaskBox insideMyTask'>
            <div className='mainWidth shadow' style={{maxWidth:900}}>

                <nav className='breadcrumbs'>
                    <Link to={`/`}>{t("home")}</Link>
                    <MdOutlineArrowLeft />
                    <Link to='/myTasks'>{t("header_user_menu_2")}</Link>
                    <MdOutlineArrowLeft />
                    <Link>{data?.task?.title}</Link>
                
                </nav>


                <Task v={data?.task} />
                
                <div className='tasksStatsBox ' >

                    <div >
                        <hr />
                        <p>
                            <b>{data?.stats?.length ? data?.stats[0] : 0}</b>
                            <span>{t("tasks_stats_4")}</span>
                        </p>
                        <PiPencil />
                    </div>
                    <div >
                        <hr />
                        <p>
                            <b>{data?.stats[1]}</b>
                            <span>{t("tasks_stats_2")}</span>
                        </p>
                        <PiStudent />
                    </div>

                    <div >
                        <hr />
                        <p>
                            <b>{data?.stats[2]}</b>
                            <span>{t("tasks_stats_7")}</span>
                        </p>
                        <PiStudent />
                    </div>


                </div>

                <div className='myTaskBody' style={{backgroundColor:"#fff"}}>
                            
                    
                    <table className='table'>
                        <thead>
                            <tr>
                                <td style={{width:40}}>#</td>
                                <td className='text-right' style={{width:'20%'}}>{t("name")}</td>
                                <td>{t("tasks_score")}</td>
                                <td>{t("status")}</td>
                                <td>{t("tasks_send_timer")}</td>
                                <td>{t("tasks_sent_date")}</td>
                                <td>{t("task_answer_2")}</td>
                            </tr>
                        </thead>

                        {data?.students?.length ? <tbody>
                            {data?.students?.map((v, k) => {
                                return (
                                    <tr key={k}>
                                        <td >{k+1}</td>
                                        <td className='text-right'>{v?.name}</td>
                                        <td>{v?.answer?.score ? <span className='tag blue'>{v?.answer?.score}%</span> : "--"}</td>
                                        <td><span className={`tag ${v?.answer?.status == 1 && 'orange'} ${v?.answer?.status == 2 && 'blue'}`}>{t(`task_student_status_${v?.answer?.status || '0'}`)}</span></td>
                                        <td>{v?.answer?.timer ? <span className='tag gray'><SecoundsToTime time={v?.answer?.timer}/></span> : "--"}</td>
                                        <td>{v?.answer?.date ? <DateToText time={v?.answer?.date}/> : "--" }</td>
                                        <td>
                                            {v?.answer?.date ? 
                                            <>
                                                <Link to={`/myTasks/student/${params?.id}/${v?._id}`} title={t("task_show_answers")} className='btn green'><MdOutlineRemoveRedEye /></Link>
                                                <a onClick={() => deleteAnswers(v?._id)} title={t("task_delete_answers")} className='btn red'><MdOutlineCleaningServices /></a>
                                            </>
                                            :
                                                <>
                                                    <Link style={{opacity:0.7}} title={t("task_show_answers")} className='btn gray'><MdOutlineRemoveRedEye /></Link>
                                                    <a style={{opacity:0.7}} title={t("task_delete_answers")} className='btn gray'><MdOutlineCleaningServices /></a>
                                                </>
                                            }
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>: false}
                    </table>

                    {!data?.students?.length ? <div className='noData'>{t("error",  { returnObjects: true })[1]}</div>: false}

                </div>

                

            </div>


        </div>
    )
}
